import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { sheetStatusLabel } from '../../../../services/sheetReview.api'
import { useSheetReviewContext } from './SheetReviewContext'

/**
 * Estado de ficha discreto (todas las pestañas excepto Ficha, donde vive el panel).
 * No se muestra si approved (sellada): no hace falta recordarlo en cada vista.
 */
export default function SheetReviewBanner() {
  const { pathname } = useLocation()
  const { showReviewUi, sheetStatus, slug } = useSheetReviewContext()

  if (!showReviewUi) return null
  if (sheetStatus === 'approved') return null

  const onFicha = /\/ficha\/?$/.test(pathname)
  // En Ficha el panel completo ya comunica el estado
  if (onFicha) return null

  const showCta = sheetStatus === 'needs_correction' || sheetStatus === 'draft'
  const ctaTo = slug ? `/personajes/${slug}/ficha#sheet-review` : '#sheet-review'

  return (
    <div className={`char-sheet-status char-sheet-status--${sheetStatus || 'draft'}`} role="status">
      <span className="char-sheet-status__label">{sheetStatusLabel(sheetStatus)}</span>
      {sheetStatus === 'in_review' ? (
        <span className="char-sheet-status__hint">Edición bloqueada mientras el staff revisa</span>
      ) : null}
      {sheetStatus === 'needs_correction' ? (
        <span className="char-sheet-status__hint">Hay correcciones pendientes</span>
      ) : null}
      {sheetStatus === 'draft' ? (
        <span className="char-sheet-status__hint">Aún no enviada a revisión</span>
      ) : null}
      {showCta && slug ? (
        <Link to={ctaTo} className="char-sheet-status__link">
          {sheetStatus === 'needs_correction' ? 'Corregir' : 'Revisar'}
        </Link>
      ) : null}
    </div>
  )
}
